import * as React from "react";
import { ResponsiveTimeRange, ResponsiveCalendar, CalendarTooltipProps, CalendarDatum, ColorScale, CalendarDayData } from "@nivo/calendar";
import * as moment from "moment";
import { useWindowSize } from "../../misc/Hooks/UseWindowSize";

export interface DiaryCalendarDayData extends CalendarDayData {
}

export interface DiaryDaybyDayCalendarProps {
    calendarData: () => CalendarDatum[];
    minYear: moment.Moment;
    maxYear: moment.Moment;
    calendarColorRange: string[];
    colorScale: () => ColorScale;
    onCalendarClick: (d: DiaryCalendarDayData) => void;
}

export const DiaryDayByDay = (props) => {
    const windowSize = useWindowSize(1200);

    return (
        <>
            {windowSize ? <DiaryDaybyDayCalendar {...props} /> : <DiaryDaybyDayTimeRange {...props} />}
        </>
    );
}

const legendFormat = (value: any) => {
    switch (value) {
        case 0: {
            return "No data recorded";
        }
        case 1: {
            return "Event";
        }
        case 2: {
            return "Test or questionnaire results";
        }
        case 6: {
            return "Session complete";
        }
    }
}

export const DiaryDaybyDayTimeRange = ({ calendarData, calendarColorRange, colorScale, onCalendarClick }) => {

    return (<ResponsiveTimeRange
        data={calendarData()}
        margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
        colors={calendarColorRange}
        colorScale={colorScale()}
        onClick={onCalendarClick}
        legendFormat={legendFormat}
        legends={[
            {
                anchor: "top",
                direction: "row",
                translateX: 0,
                translateY: -40,
                itemsSpacing: 0,
                itemDirection: "left-to-right",
                itemWidth: 180,
                itemHeight: 20,
                itemOpacity: 1,
                symbolSize: 12,
                symbolShape: "square",
                symbolBorderColor: "#e5e5e5",
                symbolBorderWidth: 1,
                itemCount: 2,
            }
        ]}
        tooltip={(e: CalendarTooltipProps) => {
            return (<div style={{ fontSize: "inherit", boxShadow: "#e5e5e5 0px 1px 2px", padding: "5px 9px", background: "#fff" }}>
                <strong>{moment(e.day).format("DD-MMM-YYYY")}</strong>
            </div>)
        }}
    />);
}

export const DiaryDaybyDayCalendar = ({ calendarData, minYear, maxYear, calendarColorRange, colorScale, onCalendarClick }: DiaryDaybyDayCalendarProps) => {
    return (<ResponsiveCalendar
        data={calendarData()}
        from={minYear.format("YYYY-MM-DD")}
        to={maxYear.format("YYYY-MM-DD")}
        margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
        colors={calendarColorRange}
        colorScale={colorScale()}
        yearSpacing={35}
        monthSpacing={35}
        monthBorderColor="#e5e5e5"
        dayBorderWidth={2}
        dayBorderColor="#e5e5e5"
        onClick={onCalendarClick}
        legendFormat={legendFormat}
        legends={[
            {
                anchor: "top",
                direction: "row",
                translateX: 0,
                translateY: -40,
                itemsSpacing: 0,
                itemDirection: "left-to-right",
                itemWidth: 180,
                itemHeight: 20,
                itemOpacity: 1,
                symbolSize: 12,
                symbolShape: "square",
                symbolBorderColor: "#e5e5e5",
                symbolBorderWidth: 1,
                itemCount: 2,
            }
        ]}
        tooltip={(e: CalendarTooltipProps) => {
            return (<div style={{ fontSize: "inherit", boxShadow: "#e5e5e5 0px 1px 2px", padding: "5px 9px", background: "#fff" }}>
                <strong>{moment(e.day).format("DD-MMM-YYYY")}</strong>
            </div>)
        }}
    />);
}
